import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IdDescription } from 'tms-lib';
import { OrderType, OrderTypeDelivery } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class OrderTypeService extends TmsWebBaseEditService<OrderType, OrderType> {
  constructor() {
    super('OrderType', $localize`Order Type`);
  }

  getForType(type: string): Observable<IdDescription[]> {
    return this.httpService.get<IdDescription[]>(`${this.apiUrl}/GetForType?type=${type}`);
  }

  // Delivery-charging flag per order type, used to warn when a type change alters delivery charging.
  getDeliveryFlags(): Observable<OrderTypeDelivery[]> {
    return this.httpService.get<OrderTypeDelivery[]>(`${this.apiUrl}/DeliveryFlags`);
  }
}
